const component = 'chip-button' as const;

export const ChipButtonVariableNames = {
  Color: `--${component}-color`,
  IconColor: `--${component}-icon-color`,
  BackgroundColor: `--${component}-background-color`,
  BorderColor: `--${component}-border-color`,
  BorderWidth: `--${component}-border-width`,
  HoverColor: `--${component}-hover-color`,
  HoverIconColor: `--${component}-hover-icon-color`,
  HoverBackgroundColor: `--${component}-hover-background-color`,
  HoverBorderColor: `--${component}-hover-border-color`,
  FocusOutlineColor: `--${component}-focus-outline-color`,
  ExpandedBackgroundColor: `--${component}-expanded-background-color`,
  ExpandedOutlineColor: `--${component}-expanded-outline-color`,
  DisabledColor: `--${component}-disabled-color`,
  DisabledIconColor: `--${component}-disabled-icon-color`,
  DisabledBackgroundColor: `--${component}-disabled-background-color`,
  Padding: `--${component}-padding`,
  Gap: `--${component}-gap`,
  Radius: `--${component}-radius`,
} as const;
